<div class="welcome-hero">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="hero-content">
          <div class="hero-badge">
            <span class="badge-text">{{ 'GENERAL.ADMIN_DASHBOARD' | translate }}</span>
          </div>
          <h1 class="hero-title">
            <span class="title-line-1">{{ 'GENERAL.WELCOME_TO' | translate }}</span>
            <span class="title-line-2">Starlinks</span>
          </h1>
          <p class="hero-subtitle">
            {{ 'AUTH_FLOW.WHEREVER_YOU_ARE_WE_RE_HERE_TO_HELP_DELIVER' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
